import moment from 'moment';
import {eventMomentFactory} from '../data/misc/eventMomentFactory';

export default function eventHumanFriendlyDate(event, start, end) {
    start = eventMomentFactory(event, start || event.start_utc);
    end = eventMomentFactory(event, end || start);

    let date = start.format('D MMM');
    if (!start.isSame(end, 'day')) {
        if (start.month() == end.month()) {
            date = start.format('D') + '-' + end.format('D MMM');
        } else {
            date = start.format('D MMM') + '-' + end.format('D MMM');
        }
    }

    if (start.year() != moment().year()) {
        date += end.format(' Y');
    }

    return date;
}
